import {
    UPDATE_ACCESS_POINTS_ACCESS_METHOD,
    UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
    UPDATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
} from 'store/actions/types';

export const updateAccessPointAccessMethod = (payload) => {
    return {
        type: UPDATE_ACCESS_POINTS_ACCESS_METHOD,
        payload: payload,
    };
};

export const updateAccessPointAccessMethodFailure = (error) => {
    return {
        type: UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
        error: error,
    };
};

export const updateAccessPointAccessMethodSuccess = (response) => {
    return {
        type: UPDATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/access-methods/edit/updateAccessPointAccessMethod.js